module.exports = __webpack_public_path__ + "static/media/canReverseBadInjury.85c6b972.mp3";